<template>
  <div :class="$style.form">
    <div :class="$style.status">
      <p :class="$style.title">ステータス</p>
      <div :class="[$style.status__buttons, $style.statusButtons]">
        <label
          v-for="option of statusOptions"
          :key="option.label"
          :class="[$style.option, $style.statusButtons__option]"
        >
          <DolphinRadioButton
            name="normalMessageChatReplyStatusType"
            :value="option.value"
            :modelValue="model.isEnabled"
            @update:modelValue="option.handler"
          />
          <span :class="$style.option__text">
            {{ option.label }}
          </span>
        </label>
      </div>
    </div>
    <div :class="[$style.form__message, $style.message]">
      <p :class="$style.title">メッセージ内容</p>
      <DolphinTextarea
        v-model="model.message"
        :class="$style.message__body"
        :rows="4"
        :autoGrow="false"
        :disabled="false"
        :invalid="!!errors?.message"
        placeholder="例) 現在、自由入力チャットには対応していません。"
      />
      <p v-if="errors?.message" :class="$style.message__error">
        {{ errors.message.at(0) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import DolphinRadioButton from '@/components/atoms/DolphinRadioButton.vue'
import DolphinTextarea from '@/components/atoms/DolphinTextarea.vue'

import {
  validateNormalMessageChatReplyPlannerSettingForm,
  type NormalMessageChatReplyPlannerSettingFormType,
} from './formSchemaForNormalMessage'

const model = defineModel<NormalMessageChatReplyPlannerSettingFormType>({
  required: true,
})

const statusOptions = [
  {
    value: true,
    label: '利用',
    handler: () => {
      model.value.isEnabled = true
    },
  },
  {
    value: false,
    label: '停止',
    handler: () => {
      model.value.isEnabled = false
    },
  },
]

const errors = computed(() =>
  validateNormalMessageChatReplyPlannerSettingForm(model.value)
)
</script>

<style lang="scss" module>
.title {
  font-size: 14px;
  font-weight: 700;
}

.form {
  &__message {
    margin-top: 24px;
  }
}

.status {
  &__buttons {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.statusButtons {
  &__option {
    &:nth-child(n + 2) {
      margin-left: 16px;
    }
  }
}

.option {
  display: inline-flex;
  align-items: center;

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}

.message {
  &__body {
    margin-top: 8px;
  }

  &__error {
    color: $color-caution-accent;
    font-size: 12px;

    &:nth-child(n + 2) {
      margin-top: 4px;
    }
  }
}
</style>
